import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LoginService } from '@features/login/services/login.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false,
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;

  constructor(private loginService: LoginService) {}

  ngOnInit(): void {
    this.loginForm = new FormGroup({
      email: new FormControl('', Validators.required),
      password: new FormControl('', Validators.required),
    });
  }

  refresh(): void {
    window.location.reload();
  }

  submitLogin() {
    const email = this.loginForm.value.email.trim();
    const password = this.loginForm.value.password;
    this.loginForm.markAllAsTouched();

    if (this.loginForm.valid) {
      this.loginService.login(email, password);
    }
  }
}
